// extracted by mini-css-extract-plugin
export default {"item":"Post_item__LfQTb","itemText":"Post_itemText__WhkLj"};